<template>
  <div class="tw:flex tw:gap-2">
    <AIFeedback
      :ai-feature-configuration-id="aiFeatureConfigurationId"
      :ai-input="{ tags }"
      :ai-result="{ keywordSuggestions }"
      animate
      :show-component="showFeedbackComponent"
      show-regenerate
      :source="source"
      @regenerate="emit('regenerateSuggestions')"
    />

    <AIButton
      v-if="features.has('has_ai_keyword_suggestion')"
      :active="isContainerOpen"
      data-testid="toggle-button"
      :disabled="isAiButtonDisabled"
      expanded
      :label="getLocaleText('suggested_keywords_ai_controls.suggest_button')"
      @click="emit('toggleAiFeature')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import AIButton from "shared/components/AI/AIButton.vue";
import AIFeedback from "shared/components/AI/AIFeedback.vue";
import type { SimpleBooleanFilter } from "shared/resources/Stream";
import features from "shared/services/features";

interface SuggestedKeywordsAIControlsProps {
  aiFeatureConfigurationId?: number;
  isContainerOpen?: boolean;
  isAiButtonClearable?: boolean;
  isAiButtonDisabled?: boolean;
  keywordSuggestions?: string[];
  tags: SimpleBooleanFilter[];
  source: string;
}

const props = defineProps<SuggestedKeywordsAIControlsProps>();

const emit = defineEmits<{
  toggleAiFeature: [];
  regenerateSuggestions: [];
}>();

const thumbsUpSubmitted = ref(false);
const thumbsDownSubmitted = ref(false);
const feedbackId = ref(0);

const showFeedbackComponent = computed(
  () =>
    props.keywordSuggestions !== undefined &&
    props.keywordSuggestions.length > 0
);

function resetFeedbackThumbs() {
  thumbsDownSubmitted.value = false;
  thumbsUpSubmitted.value = false;
  feedbackId.value = 0;
}

watch(
  () => props.keywordSuggestions,
  () => {
    resetFeedbackThumbs();
  }
);
</script>
